import firebase from 'firebase/compat/app'

export const forgotPassword = (username) => (dispatch) => {
  firebase
      .auth()
      .sendPasswordResetEmail(username)
      .then((res) => {
        dispatch({
          type: types.STORE_PAYLOAD,
          payload: {
            userMessage: 'Please check your email to change your password.',
            notificationType: 2,
            notificationIcon: 'check',
            isNotificationVisible: true,
          },
        })
      })
      .catch((err) => {
        dispatch({
          type: types.STORE_PAYLOAD,
          payload: {
            userMessage: 'Email not found. Please try again.',
            notificationType: 2,
            notificationIcon: 'warning',
            isNotificationVisible: true,
          },
        })
      })
}
